import type { ColumnType } from 'antd/es/table';

/**
 * @description: Used to add an empty column to the far right side. Only relevant for antd tables.
 */
export function padColumns<T>(columns: ColumnType<T>[]): ColumnType<T>[] {
  return [
    ...columns,
    {
      width: 24
    }
  ];
}
